import { CompiledResponse, CompiledResponseResult } from "@theprelude/core";
import {
  AlertIcon,
  CheckmarkIcon,
  Dialog,
  DialogBody,
  DialogContent,
  DialogTrigger,
} from "@theprelude/ds";
import { usePopper } from "@/hooks/use-popper";
import Editor from "../editor/editor";

function displayCompileResults(results: CompiledResponseResult[] | undefined) {
  if (!results) {
    return;
  }
  const failed: string[] = [];
  const skipped: string[] = [];
  const succeeded: string[] = [];

  results.forEach((result) => {
    const platformArch = `${result.platform} (${result.architecture})`;
    if (result.status === "FAILED") {
      failed.push(platformArch);
    }
    if (result.status === "SKIPPED") {
      skipped.push(platformArch);
    }
    if (result.status === "SUCCEEDED") {
      succeeded.push(platformArch);
    }
  });

  const skippedStr = skipped.length > 0 ? `${skipped.join(", ")}, ` : "none, ";
  const succeededStr =
    succeeded.length > 0 ? `${succeeded.join(", ")}.` : "none.";
  const nonFailureString =
    "skipped on " + skippedStr + "succeeded on " + succeededStr;

  return failed.length > 0
    ? "Compilation unsuccessful: " +
        "failed on " +
        `${failed.join(", ")}, ` +
        nonFailureString
    : "Compilation successful: " + nonFailureString;
}

export function CompileResults({ data }: { data: CompiledResponse }) {
  const dialog = usePopper();
  const failedCompile = data.results?.some((e) => e.status === "FAILED");
  const errorMessage = data.results
    ?.filter((f) => f.status === "FAILED" && f.reason)
    .map((f) => f.reason)[0];

  return (
    <>
      {failedCompile !== undefined && (
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            {failedCompile ? (
              <AlertIcon className="text-status-yellow" />
            ) : (
              <CheckmarkIcon className="text-status-green" />
            )}
            <span className="w-80 text-primary-foreground text-xs">
              {displayCompileResults(data.results)}{" "}
              {errorMessage && (
                <Dialog {...dialog}>
                  <DialogTrigger asChild>
                    <span className="underline underline-offset-2">
                      More info
                    </span>
                  </DialogTrigger>
                  <DialogContent className="max-w-fit">
                    <DialogBody className="max-h-screen">
                      <div className="flex pt-4 text-sm">
                        <Editor
                          editable={false}
                          value={errorMessage}
                          width="50vw"
                        />
                      </div>
                    </DialogBody>
                  </DialogContent>
                </Dialog>
              )}
            </span>
          </div>
        </div>
      )}
    </>
  );
}
